import type { Item } from "../../src/web/types.ts";

// A research tile's foot (features/research.md, "A tile of one height"): how many sources, what it's about
// and how many notes, "13 sources · 16 places · 1 note", each part left out when there are none. What it's
// about are places when every one is somewhere to go or to sleep (a place, a stay), else things (a journey,
// a pass, a to-do: "4 things").
export function researchFoot(sources: number, about: Pick<Item, "type">[], notes: number): string {
  const places = about.every((i) => i.type === "place" || i.type === "stay");
  return [
    count(sources, "source", "sources"),
    count(about.length, places ? "place" : "thing", places ? "places" : "things"),
    count(notes, "note", "notes"),
  ]
    .filter((part) => part !== null)
    .join(" · ");
}

const count = (n: number, one: string, many: string) => (n === 0 ? null : `${n} ${n === 1 ? one : many}`);

// A source as it's listed in full: its address without the scheme or "www.", or a trailing slash, and
// spelled as typed where it was escaped (a Japanese shop's page reads in Japanese, not as %E4%B8%AD…).
export function sourceText(url: string): string {
  try {
    const u = new URL(url);
    const rest = `${u.pathname === "/" ? "" : u.pathname.replace(/\/$/, "")}${u.search}`;
    const shown = `${u.hostname.replace(/^www\./, "")}${rest}`;
    try {
      return decodeURI(shown);
    } catch {
      return shown;
    }
  } catch {
    return url;
  }
}
